export default __webpack_public_path__ + "static/media/file.4b292648.svg";